import { FilterSet } from "./filter-interface";
import { Pagination } from "./pagination";
import { ContactCardInterface } from "./contact-card-interface";
import { MobilityContactCardInterface } from "./mobility-contact-card-interface";

export enum TileStatusEnum {
  Pending = "Pending",
  Approved = "Approved",
}

export interface TileInterface {
  id?: string;
  uniqueId?: string;
  title: string;
  text: string;
  ctaText: string;
  ctaLink: string;
  isExternalLink: boolean;
  image?: string;
  variant: "primary" | "secondary" | "tertiary" | "quaternary" | "quinary";
  size: "small" | "medium" | "large" | null;
  textDisclaimer?: string;
  status?: TileStatusEnum;
}

export enum TileTypeEnum {
  Other = 0,
  Video = 1,
}

export interface TileBase {
  id: string;
  title: string;
  text: string | null;
  link: string;
  isExternalLink: boolean;
  textDisclaimer?: string | null;
  order?: number | null;
}

export interface VideoTileDto extends TileBase {
  contentType: string;
  base64Image?: string | null;
  languages: string[];
}

export interface DevelopmentTile extends TileBase {
  delegation: string;
  base64Image?: string | null;
  isVisible: boolean;
  tileStatus: string;
  developmentTheme: string;
}

export interface MobilityTile extends TileBase {
  delegation: string;
  base64Image?: string | null;
  isVisible: boolean;
  tileStatus: string;
  mobilityTheme: string;
}

export interface PersonalizedJourneyTile extends TileBase {
  delegation: string;
  base64Image?: string | null;
  isVisible: boolean;
  tileStatus: string;
  personalizedJourneyTheme: string | null;
}

export interface TypedTile extends TileBase {
  tileType: TileTypeEnum;
}

export interface VideoSearchInterface {
  selectedFilters: FilterSet[];
  pagination: Pagination;
}

export interface VideoResultInterface {
  videoTiles: VideoTileDto[];
  pagination: Pagination;
}

export interface SearchTileInterface {
  developmentTiles: DevelopmentTile[];
  mobilityTiles: MobilityTile[];
  contactsRH: ContactCardInterface[];
  contactsMobility: MobilityContactCardInterface[];
  personalizedJourneyTilesMature: PersonalizedJourneyTile[];
  personalizedJourneyTilesUnMature: PersonalizedJourneyTile[];
  videoTiles: VideoTileDto[];
}
